<template>
  <div class="summary-loader-wrapper">
    <v-skeleton-loader
      v-for="i in numberOfMetrics"
      :key="i"
      type="heading"
      class="summary-loader mt-2"
      width="150"
    />
  </div>
</template>

<script setup>
defineProps({
  numberOfMetrics: { type: Number, default: 4 },
});
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader) {
  background: transparent;
}

:deep(.v-skeleton-loader__heading) {
  margin: 0 16px;

  &:last-child {
    margin-right: 0;
  }
}
</style>
